import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseIcon from "@mui/icons-material/Close";

const CHIP = 36;

/**
 * Shared success / failure affordances for CMS lookup actions (Medicare dates, CCN, etc.).
 * Soft chip + checkbox (success) or X (failure), with full detail in the tooltip.
 */
export function CmsLookupOutcomeSuccess({
  title,
  ariaLabel,
}: {
  title: string;
  ariaLabel: string;
}) {
  return (
    <Tooltip title={title}>
      <Box
        component="span"
        aria-label={ariaLabel}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: CHIP,
          height: CHIP,
          borderRadius: 1,
          bgcolor: "rgba(220, 252, 231, 0.96)",
          border: "1px solid",
          borderColor: "#86efac",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
        }}
      >
        <CheckBoxIcon sx={{ fontSize: 24, color: "#166534" }} />
      </Box>
    </Tooltip>
  );
}

export function CmsLookupOutcomeFailure({
  title,
  ariaLabel,
}: {
  title: string;
  ariaLabel: string;
}) {
  return (
    <Tooltip title={title}>
      <Box
        component="span"
        aria-label={ariaLabel}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: CHIP,
          height: CHIP,
          borderRadius: 1,
          bgcolor: "rgba(254, 226, 226, 0.96)",
          border: "1px solid",
          borderColor: "#fca5a5",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
        }}
      >
        <CloseIcon sx={{ fontSize: 22, color: "#b91c1c" }} />
      </Box>
    </Tooltip>
  );
}
